/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_GInputs */

const en_mk_tut_tim_g = /** @type {(inputs: Mk_Tut_Tim_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workspace is only useful once the people are in it. Invitations go out by email, and you decide who may do what.`)
};

const id_mk_tut_tim_g = /** @type {(inputs: Mk_Tut_Tim_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang kerja baru berguna kalau orangnya ada di dalam. Undangan dikirim lewat email, dan Anda menentukan siapa boleh apa.`)
};

/**
* | output |
* | --- |
* | "A workspace is only useful once the people are in it. Invitations go out by email, and you decide who may do what." |
*
* @param {Mk_Tut_Tim_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_g = /** @type {((inputs?: Mk_Tut_Tim_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_g(inputs)
	return en_mk_tut_tim_g(inputs)
});